<div class="package-mappings-card" role="region" aria-label="Package mappings">
  <div class="card-header">
    <div class="card-header-text">
      <h2 class="card-title">Package mappings</h2>
      <p class="card-description">
        Map each wash package at this location to its Way package ID.
        Only wash packages are eligible for mapping.
        Gateless membership auto-redeem requires a mapping.
      </p>
      @if (!wayConfigured) {
        <p class="field-hint way-mapping-hint">
          Set a Way vendor location ID above before redeeming. You can still prepare mappings now.
        </p>
      }
    </div>
  </div>

  @if (loading) {
    <div class="loading-container">
      <app-loading-table-shimmer
        [columns]="shimmerColumns"
        [rows]="3"
        [showHeader]="true"
        className="scrollable">
      </app-loading-table-shimmer>
    </div>
  }

  @if (!loading && packageMappings.length > 0) {
    <div class="table-container">
      <table class="mappings-table">
        <thead>
          <tr>
            <th>SaaS package</th>
            <th>Wash type</th>
            <th>Way package ID</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @for (row of packageMappings; track row.package_id) {
            <tr>
              <td class="package-name">{{ row.package_name }}</td>
              <td class="wash-type-cell">
                @let washTypeLabels = getWashTypeLabels(row);
                @if (washTypeLabels.length) {
                  <div class="wash-type-badges">
                    @for (label of washTypeLabels; track label) {
                      <span class="type-badge">{{ label }}</span>
                    }
                  </div>
                } @else {
                  <span class="type-badge">—</span>
                }
              </td>
              <td class="mapping-input-cell">
                <input
                  type="text"
                  class="form-input mapping-input"
                  [class.error]="row.fieldError"
                  [name]="'wayPackageId-' + row.package_id"
                  [(ngModel)]="row.way_package_id"
                  (ngModelChange)="onWayPackageIdChange(row)"
                  placeholder="Paste Way package ID"
                  maxlength="100"
                  [disabled]="isSaving"
                  autocomplete="off"
                  [attr.aria-label]="'Way package ID for ' + row.package_name">
                <div class="field-error-slot" [class.visible]="!!row.fieldError">
                  @if (row.fieldError) {
                    <div class="error-message">{{ row.fieldError }}</div>
                  }
                </div>
              </td>
              <td class="status-cell">
                <span
                  class="status-badge"
                  [ngClass]="getStatusClass(row)">
                  {{ getStatusLabel(row) }}
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (listError) {
      <div class="error-message package-mappings-error">{{ listError }}</div>
    }

    <div class="actions">
      <button
        type="button"
        class="secondary-btn"
        (click)="onDiscard()"
        [disabled]="isSaving || !isDirty">
        Discard
      </button>
      <button
        type="button"
        class="primary-btn"
        (click)="onSave()"
        [disabled]="isSaving || !isDirty">
        {{ isSaving ? 'Saving…' : 'Save mappings' }}
      </button>
    </div>
  }

  @if (!loading && loadFailed) {
    <div class="empty-state-container">
      <app-empty-result
        image="/assets/images/empty_screen.png"
        title="Failed to load package mappings"
        [description]="listError || 'Something went wrong while loading mappings for this location.'"
        actionText="Retry"
        [showAction]="true"
        (actionClicked)="onRetryLoad()">
      </app-empty-result>
    </div>
  }

  @if (!loading && !loadFailed && packageMappings.length === 0) {
    <div class="empty-state-container">
      <app-empty-result
        image="/assets/images/empty_screen.png"
        title="No wash packages at this location"
        description="Assign wash packages (single wash or monthly membership) to this location in shop admin first, then map them to Way package IDs here."
        [actionText]="''"
        [showAction]="false">
      </app-empty-result>
    </div>
  }
</div>
